import React, { useState, useEffect, useRef } from "react"
import { uniqueId } from "lodash"
import axios from "axios"
import {
  StyledFieldWrapper,
  StyledLookupOptions,
  StyledSelectedOption,
  StyledLoading,
} from "./partials/StyledField"
import IconV2 from "../icon-v2"

export interface LookupProps {
  id: string
  placeholder: string
  name: string
  label: string
  type: string
  required: boolean
  hidden: boolean
  disable: boolean
  value: string
  onChange: () => {}
  isValid: boolean
  isDark: boolean
  loading: boolean
  // folder_name: string
  lookup_options: string
}

const Lookup: React.FC<LookupProps> = ({
  id,
  placeholder,
  name,
  label,
  type,
  required,
  hidden,
  disable,
  value,
  onChange,
  isValid,
  isDark,
  loading,
  // folder_name,
  lookup_options,
}) => {
  const htmlId = uniqueId(id)
  let half = false
  const [titleFilter, setTitleFilter] = useState<string>("")
  // const [filteredResults, setFilteredResults] = useState<Array<any>>()
  const [exactMatch, setExactMatch] = useState<boolean>()
  const [fetching, setFetching] = useState(false); 
  const [result, setResult] = useState<Array<any>>()
  const [optionsVisible, setOptionsVisible] = useState(true); 

  const handleSearch = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `https://api.storyblok.com/v2/cdn/stories?starts_with=${lookup_options}&per_page=100&token=${process.env.GATSBY_APP_STORYBLOK_DATASOURCE_TOKEN}&version=draft&search_term=${titleFilter}&cv=2`
      );
  
      if (response) {
        const results = response.data.stories
          .map((school: any) => school.content)
          .filter(
            (content: any) =>
              content.locale_name.toLowerCase().includes(titleFilter.toLowerCase()) ||
              content.name.toLowerCase().includes(titleFilter.toLowerCase())
          );
  
        const sorted1 = results.sort((a: any, b: any) => {
          const aName: string = a.name.toLowerCase();
          const bName: string = b.name.toLowerCase();
          if (aName.indexOf(titleFilter.toLowerCase()) < bName.indexOf(titleFilter.toLowerCase())) return -1;
          if (aName.indexOf(titleFilter.toLowerCase()) > bName.indexOf(titleFilter.toLowerCase())) return 1;
  
          if (aName < bName) return -1;
          if (aName > bName) return 1;
  
          return 0;
        });
  
        setOptionsVisible(true);
        setResult(sorted1);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    handleSearch()
  }, [titleFilter])

  function handleOnClick(id, locale_name, name, value) {
    setTitleFilter(locale_name)
    onChange(id, { value: `name: ${name}, id: ${value}`, valid: true })
    setExactMatch(true)
  }

  function handleDelete(id) {
    setTitleFilter("")
    setExactMatch(false)
    onChange(id, { value: "", valid: false })
  }
  const wrapperRef = useRef(null);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOptionsVisible(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef)


  return (
    <>
      <StyledFieldWrapper
      data-name="field-lookup"
      ref={wrapperRef}
        isDark={isDark}
        hidden={hidden}
        valid={isValid}
        loading={loading}
        half={half}
        empty={!value || value.length < 1}
      >
        <div>
          {isValid && (
            <IconV2 icon={"check-circle"} size={"14"} iconType={"fas"} />
          )}
          {isValid === false && (
            <IconV2 icon={"exclamation-circle"} size={"14"} iconType={"fas"} />
          )}
          {exactMatch ? (
            <StyledSelectedOption
              isDark={isDark}
              onClick={() => handleDelete(id)}
            >
              <span>{label}</span>
              <p>{titleFilter}</p>
            </StyledSelectedOption>
          ) : (
            <>
            {fetching && (
            <StyledLoading><IconV2 icon={"spinner"} className={"fa-spin"}/></StyledLoading>
            )}
              <input
                className={placeholder && placeholder.length > 0 ? "has_placeholder" : ""}
                onFocus={() => setOptionsVisible(true)}
                id={htmlId}
                name={name}
                type={type}
                placeholder={placeholder}
                autoComplete="off"
                required={required}
                disabled={disable}
                pattern="\S(.*)?"
                value={titleFilter}
                onChange={({ target }) => {
                  setExactMatch(false)
                  setTitleFilter(target.value)
                  if (id) {
                    const { value, validity } = target
                    onChange(id, {
                      value: `name: ${value}`,
                      valid: validity.valid,
                    })
                  } else onChange(target)
                }}
              />
              {label && <label htmlFor={htmlId}>{label}</label>}
              <>
                {result &&
                  result.length > 0 &&
                  titleFilter.length > 1 &&
                  !exactMatch && (
                    <StyledLookupOptions isDark={isDark} visible={optionsVisible}>
                      {result.map((option) => (
                        <div
                          key={option.id}
                          onClick={() =>
                            handleOnClick(
                              id,
                              option.locale_name,
                              option.name,
                              option.id
                            )
                          }
                        >
                          {option.locale_name}
                        </div>
                      ))}
                    </StyledLookupOptions>
                  )}
              </>
            </>
          )}
        </div>
        {isValid === false &&
          (value.length > 0 ? (
            <span>Invalid data entry</span>
          ) : (
            <span>This is required</span>
          ))}
      </StyledFieldWrapper>
    </>
  )
}

export default Lookup
